module.exports = __webpack_public_path__ + "img/common-active.c10e8eb1.svg";